// extracted by mini-css-extract-plugin
export default {"trade-count":"_11j0x","tradeCount":"_11j0x"};